
<div mat-dialog-title>Delete Security<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>

<mat-dialog-content>$CASH cannot be deleted</mat-dialog-content>

@if ((!securityNonDeletedIds && !securityDeletedIds && !directDelete && !softResponse)) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-primary green">Close</button>
  </mat-dialog-actions>
}
@if ((securityNonDeletedIds || securityDeletedIds)) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="completeContains()" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
}
@if (directDelete) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="completeContains()" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
}
@if (softResponse) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="completeContains()" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
}
<irb-common-dialog #dialog></irb-common-dialog>


